import { Injectable } from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {first, take} from "rxjs/operators";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {CommissionMarginReport} from "../interface/commission-margin-report";
import {FilterService} from "./filter.service";
import {Terminals} from "../interface/terminals";
import {Uuid} from "../interface/response/uuid";
import {Contract} from "../interface/contract";

@Injectable({
  providedIn: 'root'
})
export class TerminalsService {
  private readonly terminalListSubject: ReplaySubject<CountedAndPaginated<Terminals>> = new ReplaySubject<CountedAndPaginated<Terminals>>(1);
  private numberOfTerminalsSuspended = 0;
  private numberOfTerminalsToBeRelized = 0;

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
  ) {
  }

  public getTerminalListSubject(): ReplaySubject<CountedAndPaginated<Terminals>> {
    return this.terminalListSubject;
  }

  public send(formData: object): Observable<any> {
    return this.httpClient.post(`/rest/crm/terminals`, formData);
  }

  public edit(formData: object, id: string): Observable<any> {
    return this.httpClient.put(`/rest/crm/terminals/${id}`, formData)   .pipe(
      take(1)
    );
  }

  public loadList(filters: object , page: number, pageSize: number,  sort?: { sortBy?: string; sortOrder?: string}): void {
    this.httpClient.get(`/rest/crm/terminal?page=${page + 1}&pageSize=${pageSize}&sortBy=${sort.sortBy ?? ''}&sortOrder=${sort.sortOrder ?? ''}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Terminals>) => {
        this.terminalListSubject.next(result);
      });
  }

  public downloadReport(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/terminal/method/report?`
      + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  public get(uuid: string): Observable<Terminals> {
    return this.httpClient.get(`/rest/crm/terminal/${uuid}`)
      .pipe(first()) as Observable<Terminals>;
  }


  public changeTerminalsImportRow(formData: any, uuid: string): Observable<any> {
    return this.httpClient.post(`/rest/crm/terminal/${uuid}/changeTerminalImportRow`, formData)
      .pipe(first());
  }

  delete(postId: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/terminal/${postId}`)
        .pipe(first());
  }

  public statusChange(uuid: string, status: number, reason?: string): Observable<any> {
    return this.httpClient.put(`/rest/crm/terminal/${uuid}/changeStatus`, {status, reason})
      .pipe(first());
  }

  public sendNote(formData: object, uuid: string): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/terminal/${uuid}/note`, formData)
      .pipe(first()) as Observable<Uuid>;
  }

  public loadNumberOfTerminals(
    page: number,
    pageSize: number,
    filters: object,
    filtersv2: object,
  ): any {
    this.httpClient.get(`/rest/crm/terminal?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Terminals>) => {
        this.numberOfTerminalsToBeRelized = result.pagination.total;
      });
    this.httpClient.get(`/rest/crm/terminal?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filtersv2))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Terminals>) => {
        this.numberOfTerminalsSuspended = result.pagination.total;
      });
  }
  public getNumberOfTerminalsToBeRealized(): number {
    return this.numberOfTerminalsToBeRelized;
  }

  public getNumberOfTerminalsSuspended(): number {
    return this.numberOfTerminalsSuspended;
  }
}
